import api from './api';

export const getSSLs = (page, params) => {
  return api.get('admin/SSL', { params: { page: page, limit: 10, order: 'createdAt', direction: 'DESC', ...params } });
};

export const getSSLsBySearch = (searchItem, search) => {
  return api.get(`admin/SSL?searchItem=${searchItem}&search=${search}`);
};

export const updateSSl = (sslId, update) => {
  return api.put(`admin/SSL/item/${sslId}`, { object: update });
};
